(() => {
  'use strict';

  // -----------------------------
  // 共通：ドロップダウン（高さニュルッ）
  // -----------------------------
  const createDropdown = (root, opts) => {
    if (!root || root.dataset.tyzoInited === '1') return;
    root.dataset.tyzoInited = '1';

    const toggle  = root.querySelector(opts.toggleSel);
    const panel   = root.querySelector(opts.panelSel);
    if (!toggle || !panel) return;

    let isAnimating = false;
    let isOpenState = false;

    const setHeight = (v) => { panel.style.height = (typeof v === 'number') ? `${v}px` : v; };
    const getCurrentHeight = () => panel.getBoundingClientRect().height;

    const onEnd = (e) => {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      if (isOpenState) setHeight('auto');
      else { panel.style.display = 'none'; setHeight(0); }
      isAnimating = false;
    };

    const open = () => {
      if (isAnimating || isOpenState) return;
      isAnimating = true;
      isOpenState = true;
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.style.display = 'block';
      setHeight(0);
      requestAnimationFrame(() => {
        setHeight(panel.scrollHeight);
        panel.addEventListener('transitionend', onEnd);
      });
    };

    const close = () => {
      if (isAnimating || !isOpenState) return;
      isAnimating = true;
      isOpenState = false;
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      setHeight(getCurrentHeight());
      requestAnimationFrame(() => {
        setHeight(0);
        panel.addEventListener('transitionend', onEnd);
      });
    };

    // init
    panel.style.display = 'none';
    setHeight(0);
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      isOpenState ? close() : open();
    });

    document.addEventListener('pointerdown', (e) => {
      if (!isOpenState) return;
      const path = e.composedPath ? e.composedPath() : [];
      if (path.includes(root)) return;
      close();
    }, true);

    return { open, close };
  };

  // -----------------------------
  // Sort UI（既存の挙動維持：facets.js にイベント送る）
  // -----------------------------
  const initTyzoSort = () => {
    document.querySelectorAll('[data-tyzo-sort]').forEach((root) => {
      if (root.dataset.tyzoSortInited === '1') return;
      root.dataset.tyzoSortInited = '1';

      const toggle  = root.querySelector('[data-tyzo-sort-toggle]');
      const panel   = root.querySelector('[data-tyzo-sort-panel]');
      const current = root.querySelector('[data-tyzo-sort-current]');
      const select  = root.querySelector('[data-tyzo-sort-select]');
      if (!toggle || !panel || !select) return;

      const dd = createDropdown(root, { toggleSel: '[data-tyzo-sort-toggle]', panelSel: '[data-tyzo-sort-panel]' });
      if (!dd) return;

      const fireFacetEvents = (el) => {
        el.dispatchEvent(new Event('input',  { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      };

      panel.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-value]');
        if (!btn) return;

        const v = btn.getAttribute('data-value');
        if (!v) return;

        if (current) current.textContent = btn.textContent.trim();

        if (select.value !== v) {
          select.value = v;
          fireFacetEvents(select);
        }
        dd.close();
      });
    });
  };

  // -----------------------------
  // PerPage UI（★今いるURLへ遷移：/search固定やめる）
  // -----------------------------
  // PerPage UI（今のURLをベースに per_page だけ差し替え）
const initTyzoPerPage = () => {
  document.querySelectorAll('[data-perpage]').forEach((root) => {
    if (root.dataset.tyzoPerpageInited === '1') return;
    root.dataset.tyzoPerpageInited = '1';

    const panel  = root.querySelector('[data-perpage-panel]');
    if (!panel) return;

    const dd = createDropdown(root, { toggleSel: '[data-perpage-toggle]', panelSel: '[data-perpage-panel]' });
    if (!dd) return;

    panel.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-value]');
      if (!btn) return;

      const v = btn.getAttribute('data-value');
      if (!v) return;

      const url = new URL(window.location.href);
      url.searchParams.set('per_page', v);
      url.searchParams.delete('page'); // ←元JSと同じ

      // ★searchページだけ type=product を維持したいならここで条件付け
      if (window.location.pathname.startsWith('/search')) {
        url.searchParams.set('type', 'product');
      } else {
        // コレクションに type が残ってたら事故るので除去（保険）
        url.searchParams.delete('type');
      }

      window.location.href = url.toString();
    });
  });
};

  const initAll = () => {
    initTyzoSort();
    initTyzoPerPage();
  };

  // 初回
  initAll();

  // facets.js のDOM差し替え後も復活させる
  const target = document.querySelector('#ProductGridContainer') || document.body;
  const mo = new MutationObserver(() => initAll());
  mo.observe(target, { childList: true, subtree: true });
})();